export const globalThreatMetaKeys = {
  all: ["globalThreatMeta"] as const,
  meta: (name?: string, type?: any) => [...globalThreatMetaKeys.all, name, type] as const,
};
